'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n position: absolute;\n top: ', 'px;\n left: ', 'px;\n width: 100%;\n height: 100%;\n background-image: url(', ');\n background-repeat: no-repeat;\n'], ['\n position: absolute;\n top: ', 'px;\n left: ', 'px;\n width: 100%;\n height: 100%;\n background-image: url(', ');\n background-repeat: no-repeat;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/** @class Frame
  * An individual frame in an animation layer.
  * @prop {number} top - the distance from the top of the frame to the viewport
  * @prop {number} left - the distance the frame is left of the Viewport
  * @prop {url} image - the image to display in the frame
  */
var Frame = _styledComponents2.default.div(_templateObject, function (props) {
  return props.y;
}, function (props) {
  return props.x;
}, function (props) {
  return props.image;
});

/** @class AnimationLayer
 * Renders a series of animated frames on the stage.
 * @prop {object} frames - the image urls to display on stage
 * @prop {number} x - the horizontal position of the image on stage
 * @prop {number} y - the vertical position of the image on stage
 * @prop {number} width - the width of the image on stage
 * @prop {number} height - the height of the image on stage
 * @prop {framesPerSecond} integer - the speed of the animation
 */

var AnimationLayer = function (_Component) {
  _inherits(AnimationLayer, _Component);

  /** @constructor
    * Creates a new instance of AnimationLayer
    */
  function AnimationLayer(props) {
    _classCallCheck(this, AnimationLayer);

    var _this = _possibleConstructorReturn(this, (AnimationLayer.__proto__ || Object.getPrototypeOf(AnimationLayer)).call(this, props));

    _this.state = {
      frame: 0,
      images: Object.values(props.frames).map(function (frame) {
        return frame.image;
      })
    };
    _this.advanceFrame = _this.advanceFrame.bind(_this);
    return _this;
  }
  /** @method advanceFrame
    * Advances the animation by a frame.
    */


  _createClass(AnimationLayer, [{
    key: 'advanceFrame',
    value: function advanceFrame() {
      var newFrame = this.state.frame + 1;
      if (newFrame >= this.state.images.length) newFrame = 0;
      this.setState({ frame: newFrame });
    }
    /** @method componentWillMount
      * Starts the animation interval.
      */

  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var ms = 1000.0 / this.props.framesPerSecond;
      this.interval = setInterval(this.advanceFrame, ms);
    }
    /** @method componentWillUnmount
      * Clears the animation interval.
      */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.interval);
    }
    /** @method componentWillReceiveProps
      * Restarts the animation interval with new speed
      */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.framesPerSecond) {
        if (this.interval) clearInterval(this.interval);
        var ms = 1000.0 / nextProps.framesPerSecond;
        this.interval = setInterval(this.advanceFrame, ms);
      }
    }
    /** @method render
      * Renders the component
      */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(Frame, _extends({}, this.props, { image: this.state.images[this.state.frame] }));
    }
  }]);

  return AnimationLayer;
}(_react.Component);

exports.default = AnimationLayer;
;

AnimationLayer.propTypes = {
  frames: _propTypes2.default.object.isRequired,
  x: _propTypes2.default.number.isRequired,
  y: _propTypes2.default.number.isRequired,
  width: _propTypes2.default.number.isRequired,
  height: _propTypes2.default.number.isRequired,
  framesPerSecond: _propTypes2.default.number.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/stage/animation-layer.js
// module id = 1193
// module chunks = 0